import React from 'react';
import { useParams } from 'react-router-dom';
import HeaderInner from "../components/HeaderInner";

const servicesData = {
  "two-wheelers": {
    title: "Two Wheelers Service",
    image: "/project/images/services-img.png",
    description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam expedita, fugiat est iste eveniet a magnam impedit ipsam laudantium quidem!",
    details: [
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, consequuntur obcaecati mollitia reprehenderit fuga blanditiis excepturi laboriosam quam facere repellat!",
      "Voluptatem officia doloribus voluptate hic quis officiis dolorum iure. Totam earum veniam cum odio mollitia, aliquam magnam enim rerum exercitationem amet esse sit sint voluptates modi atque illum?",
      "Molestias rerum suscipit exercitationem aut dolore ratione earum ullam tempore?"
    ],
  },
  "four-wheelers": {
    title: "Four Wheelers Service",
    image: "/project/images/services-img2.png",
    description: "Four wheelers service description goes here. We offer quality service for all types of four wheel vehicles.",
    details: [
      "Four wheelers require detailed maintenance checks for optimal performance.",
      "Our service ensures safety and reliability on every trip.",
      "We provide expert advice and quality replacement parts."
    ],
  },
  "trucks": {
    title: "Truck Service",
    image: "/project/images/services-img3.png",
    description: "Truck servicing is critical for heavy vehicles. Our team specializes in truck maintenance and repairs.",
    details: [
      "Trucks need robust servicing to handle long-haul journeys.",
      "We check engine health, brakes, and other critical systems.",
      "Our expert technicians ensure your truck stays roadworthy and efficient."
    ],
  },
};

const ServiceDetails = () => {
  const { serviceId } = useParams();
  const service = servicesData[serviceId];

  if (!service) {
    return <h2 className="text-center">Service not found</h2>;
  }

 return (
    <>
      <HeaderInner title={service.title} />
      <section className="service-details pt-6 pb-6">
        <div className="container">
          <div className="row">
            {/* Image */}
            <div className="col-lg-6">
              <img src={service.image} alt={service.title} className="img-fluid w-100" />
            </div>
            {/* Content */}
            <div className="col-lg-6">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
              {service.details.map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ServiceDetails;
